import gsap from 'gsap';
import '../libs/SplitText';

export function init() {
  const textRevealEls = document.querySelectorAll('[data-js-text-reveal]');

  [...textRevealEls].forEach(item => {
    // Break into words
    const split = new SplitText(item, {
      type: "words",
      wordsClass: 'c-text-reveal__word'
    });

    const words = document.querySelectorAll('.c-text-reveal__word');

    // Wrap each word in span for animating
    [...words].forEach(w => {
      wrapInner(w);
    });

    // Show the text
    [...textRevealEls].forEach(item => item.classList.add('c-text-reveal--is-visible'));

    // Animate each word
    const tl = gsap.timeline();
    tl.fromTo('.c-text-reveal__word span', { yPercent: 100, opacity: 0 }, { yPercent: 0, opacity: 1, duration: 1.4, stagger: 0.05, ease: "power3.out" });
  });
}

const wrapInner = (toWrap, wrapper) => {
  wrapper = wrapper || document.createElement('span');
  wrapper.innerHTML = toWrap.innerHTML;
  toWrap.innerHTML = '';
  toWrap.appendChild(wrapper);
};